import { PreviewCard as HoverCardPrimitive } from "@base-ui/react/preview-card";

import { cn } from "frontend-components/lib/utils";

function HoverCard({ ...props }: HoverCardPrimitive.Root.Props) {
    return <HoverCardPrimitive.Root data-slot="hover-card" {...props} />;
}

function HoverCardTrigger({
    delay = 300,
    closeDelay = 150,
    ...props
}: HoverCardPrimitive.Trigger.Props) {
    return (
        <HoverCardPrimitive.Trigger
            data-slot="hover-card-trigger"
            delay={delay}
            closeDelay={closeDelay}
            {...props}
        />
    );
}

function HoverCardContent({
    className,
    align = "center",
    alignOffset = 0,
    side = "bottom",
    sideOffset = 8,
    ...props
}: HoverCardPrimitive.Popup.Props &
    Pick<HoverCardPrimitive.Positioner.Props, "align" | "alignOffset" | "side" | "sideOffset">) {
    return (
        <HoverCardPrimitive.Portal>
            <HoverCardPrimitive.Positioner
                align={align}
                alignOffset={alignOffset}
                side={side}
                sideOffset={sideOffset}
                className="isolate z-50"
            >
                <HoverCardPrimitive.Popup
                    data-slot="hover-card-content"
                    className={cn(
                        "z-50 w-64 origin-(--transform-origin) rounded-card border border-compendia-border bg-compendia-card p-3 text-body-sm text-compendia-foreground shadow-md outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
                        className,
                    )}
                    {...props}
                />
            </HoverCardPrimitive.Positioner>
        </HoverCardPrimitive.Portal>
    );
}

export { HoverCard, HoverCardContent, HoverCardTrigger };
